import React from 'react';
export function Appendix3DSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-53">
      <div className="flex flex-col w-full h-full min-h-0" data-id="element-54">
        {/* Top Panel */}
        <div className="flex flex-col justify-center w-full flex-shrink-0 min-h-0" style={{
        padding: 'clamp(1.5rem, 3vw, 2.5rem) var(--slide-padding) 0'
      }} data-id="element-55">
          <div className="flex items-baseline gap-4 mb-[clamp(0.5rem,1vw,1rem)] animate-fade-slide" style={{
          animationDelay: '0.1s'
        }} data-id="element-56">
            <p className="italic font-semibold" style={{
            color: '#4A90D9',
            fontSize: 'var(--body-size)'
          }} data-id="element-57">
              Experiment 04
            </p>
            <h2 className="font-black tracking-tight text-white leading-[1.1]" style={{
            fontSize: 'var(--h2-size)'
          }} data-id="element-58">
              Procedural 3D from open data
            </h2>
          </div>
          <p className="text-white/70 leading-relaxed animate-fade-slide max-w-4xl" style={{
          fontSize: 'var(--body-size)',
          animationDelay: '0.2s'
        }} data-id="element-59">
            Generating buildings, trees, terrain, and street furniture from OSM
            and elevation data with zero manual modeling. Exploring what a
            pedestrian-scale 3D map looks like when it can spin up for any city
            automatically.
          </p>
        </div>

        {/* Bottom Panel */}
        <div className="flex-1 flex items-center justify-center p-[var(--slide-padding)] min-h-0 relative" data-id="element-60">
          <div className="w-full h-full relative rounded-xl overflow-hidden animate-fade-slide" style={{
          animationDelay: '0.3s'
        }} data-id="element-61">
            <img src="https://cdn.magicpatterns.com/uploads/5Zm3Sr5BBX9a9jakaXpwF2/Procedural_3D_.png" alt="Procedural 3D city generation" className="absolute inset-0 w-full h-full object-cover rounded-xl" style={{
            boxShadow: '0 20px 40px rgba(0,0,0,0.4)'
          }} data-id="element-62" />
          </div>
        </div>
      </div>
    </section>;
}